import InfoModal from "@/components/core/modals/InfoModal";
import { requestUpdateAlertRecapPreferences } from "@/state/alertRecapPreferences/AlertRecapPreferencesEffects";
import { AlertRecapBundleByEnum } from "@/utils/enums/alert.recap.bundle.by.enum";
import { toastError } from "@/utils/helpers/toast-helper";
import { Col, Radio, RadioChangeEvent, Row, Space } from "antd";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface AlertPreferencesProps {
  bundleBy?: AlertRecapBundleByEnum;
  setBundleBy: (bundleBy: AlertRecapBundleByEnum) => void;
}

const AlertPreferences: FunctionComponent<AlertPreferencesProps> = ({
  bundleBy,
  setBundleBy,
}) => {
  const { t } = useTranslation();

  const handleBundleByChange = (e: RadioChangeEvent) => {
    const newBundleBy = e.target.value as AlertRecapBundleByEnum;
    void requestUpdateAlertRecapPreferences({
      dto: { bundleBy: newBundleBy },
    }).catch(() => {
      toastError(t("error.toast.recapPreferences.alert"));
    });
    setBundleBy(newBundleBy);
  };

  return (
    <Row gutter={16} className="mt-48">
      <Col span={24} sm={24} md={4} xl={6} />
      <Col span={24} sm={12} md={8} xl={6}>
        <div className="d-flex align-items-center flex-wrap">
          {t("account.myPreferences.recap.groupBy")}
          <InfoModal value="groupByNotification" className="ml-4" />
        </div>
      </Col>
      <Col span={24} sm={12}>
        <Radio.Group onChange={handleBundleByChange} value={bundleBy}>
          <Space direction="vertical" size={0}>
            <Radio value={AlertRecapBundleByEnum.OFFICE_THEN_OBJECT}>
              {t("account.myPreferences.recap.officeThenObject")}
            </Radio>
            <Radio value={AlertRecapBundleByEnum.OBJECT_THEN_OFFICE}>
              {t("account.myPreferences.recap.objectThenOffice")}
            </Radio>
            <Radio value={AlertRecapBundleByEnum.OBJECT_ONLY}>
              {t("account.myPreferences.recap.objectOnly")}
            </Radio>
          </Space>
        </Radio.Group>
      </Col>
    </Row>
  );
};

export default AlertPreferences;
